import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, Button, Input, makeStyles } from '@material-ui/core';
import { useAutoClearSearchQuery, useSearchQuery } from '../services/SearchQueryContext';
import { useDebounce, useTranslations } from 'examsbook-react-sdk/custom-hooks';
import PackageCard from '../components/PackageCard/PackageCard';
import TestSeriesLoader from '../components/common/loaders/TestSeriesLoader';
import NotFound from './NotFound';
import { ReactComponent as SearchIcon } from '../assets/images/search.svg';
import { ReactComponent as CrossIcon } from '../assets/images/close.svg';
import { getUserCourseGroup } from 'examsbook-react-sdk/actions';
import '../components/CoursesList/coursesList.scss';

const normalizeCourseGroup = (group) => ({
    _id: group?._id,
    name: group?.name || '',
    description: group?.description || '',
    featured: group?.image || '',
    isSelfLearning: false,
    isLive: false,
    isUserCourse: true,
    progressPercent: group?.progressPercent || 0,
    pricing: 'FREE',
    dueDateinDays: group?.groupExipry || 0,
    courseTotalPoint: group?.courseTotalPoint || 0,
    userAwardedPoint: group?.userAwardedPoint || 0,
    neverExpired: false,
    assignedCourseEndDate: group?.assignedCourseEndDate || null,
    created: group?.created || { on: new Date().toISOString() },
    creator: group?.created?.by?.name || '',
    creatorImage: group?.created?.by?.profileImage || '',
    courses: Array.isArray(group?.courses) ? group.courses : [],
});

function CoursePackage() {
    useAutoClearSearchQuery();
    const t = useTranslations();
    const history = useHistory();
    const dispatch = useDispatch();
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const classes = useStyles(isFirefox);
    const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);
    const user = useSelector((state) => state.user);
    const userId = user?.user?._id ? user?.user?._id : user?._id;
    // const userid = useSelector((state) => state.userReducers.userData?.id);
    const { searchQuery, setSearchQuery } = useSearchQuery();
    const debouncedSearch = useDebounce(searchQuery, 500);
    const [contentData, setContentData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getUserCourseGroupData(debouncedSearch);
    }, [debouncedSearch]);

    const getUserCourseGroupData = async (search = '') => {
        try {
            setIsLoading(true);
            const res = await dispatch(getUserCourseGroup(userId, 0, 50, search));
            const groups = Array.isArray(res?.data) ? res?.data : [];
            const normalizedGroups = groups
                .map((item) => normalizeCourseGroup(item))
                .sort((a, b) => new Date(b?.created?.on || 0) - new Date(a?.created?.on || 0));

            setContentData(normalizedGroups);
        } catch (error) {
            console.error('Failed to fetch course package list:', error);
            setContentData([]);
        } finally {
            setIsLoading(false);
        }
    };

    function clearField() {
        setSearchQuery('');
    }

    const renderLoader = () => (
        <Box className="card-view test-series">
            {Array.from({ length: 8 }, (_, index) => (
                <TestSeriesLoader key={index} />
            ))}
        </Box>
    );

    return (
        <Box className="main-div">
            <Box className="course-search-box">
                <Input
                    className="inner-search-box"
                    style={{ border: 'none' }}
                    type="text"
                    placeholder={t('Search')}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Box className="course-search-img-box">
                    {searchQuery.length ? (
                        <Button onClick={clearField} style={{ border: 'none' }}>
                            <CrossIcon className="cross-icon" alt="Cross Icon" />
                        </Button>
                    ) : (
                        <SearchIcon className="search-icon" alt="Search Icon" />
                    )}
                </Box>
            </Box>

            <Box className="card-list-div">
                {isLoading && (!contentData || contentData.length === 0) ? (
                    renderLoader()
                ) : contentData.length > 0 ? (
                    <Box className="card-view-new test-series-new">
                        {contentData.map((data) => (
                            <Box key={data._id} onClick={() => history.push(`/course-package/${data._id}`, { packageData: data })} style={{ cursor: 'pointer' }}>
                                <Box style={{ pointerEvents: 'none' }}>
                                    <PackageCard
                                        testData={data}
                                        dueDateinDays={data.dueDateinDays}
                                        settingsData={settingsData}
                                        certificateListing={[]}
                                        hideExpiredStatus
                                    />
                                </Box>
                            </Box>
                        ))}
                    </Box>
                ) : (
                    <Box className={classes.centerAlign}>
                        <NotFound />
                    </Box>
                )}
            </Box>
        </Box>
    );
}

const useStyles = makeStyles(() => ({
    centerAlign: (isFirefox) => ({
        textAlign: isFirefox ? '-moz-center' : '-webkit-center',
    }),
}));

export default CoursePackage;
